/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import { SidebarMenuDetailsUseStyles } from 'components/sidebar/SidebarMenuDetailsUseStyles';
import { FiltersDetailsUseStyles } from 'components/common/components/filters/FiltersUseStyles';
import { formStyles } from 'consts/styles/Form';
import EachSideContentHandler from './EachSideContentHandler';
import EachSideContentHandlerDashboard from './EachSideContentHandlerDashboard';

const a11yProps = index => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

const ContentSwitcher = props => {
  const { textLeft, textRight, LeftElement, RightElement, dashboard } = props;
  const [value, setValue] = React.useState(0);

  const classesFilters = FiltersDetailsUseStyles();
  const classesSidebar = SidebarMenuDetailsUseStyles();
  const formClasses = formStyles();

  const tabsAction = React.useRef();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      tabsAction.current.updateIndicator();
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [LeftElement, RightElement]);

  return (
    <>
      <div
        className={`${classesSidebar.SidebarMenuDetails}__table__details__filters`}
      >
        <Tabs
          className={`${classesFilters.FiltersDetails}__table ${classesFilters.FiltersDetails}__table--padding ${formClasses.Form}__tabs`}
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          indicatorColor="primary"
          variant="fullWidth"
          centered
          classes={{
            root: `${formClasses.Form}__text-field`,
            indicator: `${formClasses.Form}__tabs__button ${formClasses.Form}__tabs__button--width`,
          }}
          action={tabsAction}
        >
          <Tab label={textLeft} {...a11yProps(0)} />
          <Tab label={textRight} {...a11yProps(1)} />
        </Tabs>
      </div>
      {dashboard ? (
        <>
          <EachSideContentHandlerDashboard value={value} index={0}>
            {LeftElement}
          </EachSideContentHandlerDashboard>
          <EachSideContentHandlerDashboard value={value} index={1}>
            {RightElement}
          </EachSideContentHandlerDashboard>
        </>
      ) : (
        <>
          <EachSideContentHandler value={value} index={0}>
            {LeftElement}
          </EachSideContentHandler>
          <EachSideContentHandler value={value} index={1}>
            {RightElement}
          </EachSideContentHandler>
        </>
      )}
    </>
  );
};

ContentSwitcher.propTypes = {
  textLeft: PropTypes.string.isRequired,
  textRight: PropTypes.string.isRequired,
  LeftElement: PropTypes.element.isRequired,
  RightElement: PropTypes.element.isRequired,
  dashboard: PropTypes.bool,
};

export default ContentSwitcher;
